import { autoinject, transient } from "aurelia-framework";
import { MdmPipelineClientService } from "../../../../../../services/modules/mdm-pipeline.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";

@autoinject()
@transient()
export class PipelineExecutionWarningDialog {

    public process: any;
    public comments: string;

    constructor(protected mdmPipelineClientService: MdmPipelineClientService,
        protected dialogClientService: DialogClientService,
        protected notificationClientService: NotificationClientService) { }

    activate(model: { process: any }) {
        this.process = model.process;
        this.comments = this.process.warningClearedComments;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    clearWarning() {
        return new Promise<void>((resolve, reject) => {

            if (!this.comments || this.comments.trim() == "") {
                this.notificationClientService.show("Clear Comments are required", "", NotificationType.Error);
                reject();
                return;
            }
            this.mdmPipelineClientService.clearEtlProcessExecutionWarning(this.process.etlProcessExecutionId, this.comments).then(response => {

                this.updateEtlProcessExecution(response.updated);

                this.dialogClientService.hide();
                this.notificationClientService.show("Warnings cleared successfully", "", NotificationType.Success);

                resolve();
            }).catch(() => {
                this.notificationClientService.show("Failed to clear warnings", "", NotificationType.Error);
                reject();
            })
        });
    }

    failPipeline() {
        return new Promise<void>((resolve, reject) => {
            if (!this.comments || this.comments.trim() == "") {
                this.notificationClientService.show("Clear Comments are required", "", NotificationType.Error);
                reject();
                return;
            }
            this.mdmPipelineClientService.failEtlProcessExecution(this.process.etlProcessExecutionId, this.comments).then(response => {

                this.updateEtlProcessExecution(response.updated);

                this.dialogClientService.hide();
                this.notificationClientService.show("Pipeline marked as failed successfully", "", NotificationType.Success);

                resolve();
            }).catch(() => {
                this.notificationClientService.show("Failed to mark pipeline as failed", "", NotificationType.Error);
                reject();
            })
        });
    }

    private updateEtlProcessExecution(updated: any) {
        this.process.isWarningCleared = updated.isWarningCleared;
        this.process.warningClearedBy = updated.warningClearedBy;
        this.process.warningClearedComments = updated.warningClearedComments;
        this.process.warningClearedOn = updated.warningClearedOn;
        this.process.requiresAction = updated.requiresAction;
        this.process.status = updated.status;
        this.process.statusClass = updated.statusClass;
    }
}